import { render, staticRenderFns } from "./SimulationView.vue?vue&type=template&id=1c1206d4&"
import script from "./SimulationView.vue?vue&type=script&lang=js&"
export * from "./SimulationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports